
const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_9bEJNUXWf",
    "aws_user_pools_web_client_id": "4b3b9j0rm0nmgbteonc20nfi09",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "peopleCountAPI",
            "endpoint": "https://5t9pic2ehh.execute-api.ap-northeast-1.amazonaws.com/dev/",
            "region": "ap-northeast-1"
        },
    ]

};


export default awsmobile;
